import React, { useEffect, useState } from 'react';
import { UnderlinedTextInput } from 'library';
import { Grid } from '@material-ui/core';
import { BusinessData } from './BusinessModels';

export default function BusinessSignup({
    updateBusinessData,
    updateError,
    businessType,
    state,
}: {
    updateBusinessData: (data: BusinessData) => void;
    updateError: (error: boolean) => void;
    businessType: 'CHILD_CARE' | 'ELDERCARE';
    state?: string;
}) {
    const [name, setName] = useState<string>();
    const [programId, setProgramId] = useState<string>();
    const [nameError, setNameError] = useState<boolean>(false);

    function getProgramText() {
        if (businessType === 'ELDERCARE') {
            return 'Facility Id';
        }

        if (state === 'Florida') {
            return 'License Number';
        }

        return 'Provider/Program ID';
    }

    const programText = getProgramText();

    useEffect(() => {
        setNameError(name === '');

        if (!!name && !nameError) {
            const data: BusinessData = { name, programId };
            updateBusinessData(data);
            updateError(false);
        } else {
            updateError(true);
        }
    }, [name, nameError, programId]);

    return (
        <Grid container item xs={12}>
            <UnderlinedTextInput
                id="txtBusinessName"
                label="Business Name*"
                value={name ? name : ''}
                onChange={(value: string) => setName(value)}
                error={nameError}
                errorText={'Please enter a business name.'}
            />
            <UnderlinedTextInput
                id="txtProgramId"
                label={programText}
                value={programId ? programId : ''}
                onChange={(value: string) => setProgramId(value)}
                error={false}
                errorText=""
            />
        </Grid>
    );
}
